import createFetchDuck from '../../util/genericEntityDuck';

const namespace = 'settings';
export const storeKey = 'externalUsers';
const duck = createFetchDuck(namespace, storeKey, 'id', namespace);

export default duck;
export const { creators, reducer, types, selectors } = duck;
